
import { createStore } from 'vuex'

export default createStore({
  state: {
    index: 0
  },
  mutations: {
    chengindex (state, value) {
      state.index = value
    }
  },
  actions: {
  },
  modules: {
  }
})
